import { useDrag } from "react-dnd";
import { useTranslation } from "react-i18next";

import { ResponseIcon } from "../../../../../../assets/icons/ResponseIcon";
import { RuleIcon } from "../../../../../../assets/icons/RuleIcon";
import {
  DraggableNodeContainer,
  IconContainer,
  NodeLibraryContainer,
} from "./NodesLibrary.styles";

function DraggableNode({ type, label }: any) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "NODE",
    item: { type },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <DraggableNodeContainer ref={drag} isDragging={isDragging}>
      <IconContainer>
        {type === "ruleNode" ? (
          <RuleIcon />
        ) : (
          <ResponseIcon style={{ marginTop: "1px" }} />
        )}
      </IconContainer>
      {label}
    </DraggableNodeContainer>
  );
}

export function NodeLibrary() {
  const { t } = useTranslation();

  return (
    <NodeLibraryContainer>
      <DraggableNode type="ruleNode" label={t("workflows_nodes_rule")} />
      <DraggableNode
        type="responseNode"
        label={t("workflows_nodes_response")}
      />

      <p>{t("workflows_nodes_hint")}</p>
    </NodeLibraryContainer>
  );
}
